import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { formatApiError } from "@/lib/api";
import { ArrowRight, Warning } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@pcpviaria.com");
  const [password, setPassword] = useState("admin123");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || "Erro no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell" data-testid="login-page">
      <div className="login-visual">
        <img src="https://images.unsplash.com/photo-1772852340517-b11ec88979fc?crop=entropy&cs=srgb&fm=jpg&q=85" alt="Construção viária" />
        <div className="login-visual-content">
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div style={{ width: 44, height: 44, background: "#FFCC00", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 3 }}>
                <span className="font-display font-black text-black text-xl">PCP</span>
              </div>
              <div>
                <div className="font-display font-black text-white text-xl leading-none">SINALIZAÇÃO VIÁRIA</div>
                <div className="overline" style={{ color: "#FFCC00" }}>Sistema PCP · v1.0</div>
              </div>
            </div>
            <div className="safety-stripes" style={{ width: 80, marginBottom: 32 }} />
            <h1 className="font-display font-black text-white" style={{ fontSize: "3rem", lineHeight: 1, marginBottom: 24 }}>
              Planejamento &<br />Controle da Produção
            </h1>
            <p style={{ color: "#D4D4D8", fontSize: "1.05rem", maxWidth: 480, lineHeight: 1.6 }}>
              Gerencie contratos, ordens de serviço, apontamentos de campo e equipes de sinalização
              vertical, horizontal, defensas e tachas em um só lugar.
            </p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16 }}>
            {[
              { n: "01", t: "Contratos & OS" },
              { n: "02", t: "Apontamento Mobile" },
              { n: "03", t: "Dashboards em Tempo Real" },
            ].map((k) => (
              <div key={k.n}>
                <div className="font-mono font-bold" style={{ color: "#FFCC00", fontSize: "0.85rem" }}>{k.n}/</div>
                <div className="text-white font-semibold text-sm mt-1">{k.t}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="login-form-wrap">
        <form onSubmit={submit} style={{ width: "100%", maxWidth: 400 }}>
          <div className="overline mb-2">Acesso</div>
          <h2 className="font-display font-black" style={{ fontSize: "2.25rem", lineHeight: 1, marginBottom: 8 }}>
            Entrar no sistema
          </h2>
          <p style={{ color: "#52525B", marginBottom: 32, fontSize: "0.95rem" }}>
            Informe suas credenciais para acessar o painel operacional.
          </p>

          <div style={{ marginBottom: 16 }}>
            <label className="label" htmlFor="email">E-mail</label>
            <input
              id="email"
              type="email"
              className="input input-lg"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              autoComplete="email"
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label className="label" htmlFor="password">Senha</label>
            <input
              id="password"
              type="password"
              className="input input-lg"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              autoComplete="current-password"
            />
          </div>

          {err && (
            <div style={{
              padding: 12, background: "#FEE2E2", border: "1px solid #FCA5A5",
              borderRadius: 3, marginBottom: 16, color: "#991B1B", fontSize: "0.85rem",
              display: "flex", alignItems: "center", gap: 8,
            }} data-testid="login-error">
              <Warning size={16} weight="bold" /> {err}
            </div>
          )}

          <button type="submit" className="btn btn-dark btn-lg btn-block" disabled={loading} data-testid="login-submit">
            {loading ? "Entrando…" : (<>Entrar <ArrowRight size={18} weight="bold" /></>)}
          </button>

          <div style={{ marginTop: 32, padding: 16, background: "#F4F4F5", borderRadius: 3, fontSize: "0.8rem", color: "#52525B" }}>
            <strong style={{ color: "#0A0A0A" }}>Acesso padrão:</strong><br />
            E-mail: admin@pcpviaria.com<br />
            Senha: admin123
          </div>
        </form>
      </div>
    </div>
  );
}
